"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _classnames = _interopRequireDefault(require("classnames"));

var _step = _interopRequireDefault(require("@alifd/next/lib/step"));

var _getDisplayName = _interopRequireDefault(require("../../utils/getDisplayName"));

var _withWindConfig = _interopRequireDefault(require("../../utils/withWindConfig"));
/* eslint-disable react/static-property-placement */

/**
 * 提供size: 'small'选项，（目前仅对圆形step有效）
 */


var enhance = function enhance(WrappedComponent) {
  // eslint-disable-next-line react/prefer-stateless-function
  var EnhancedStep =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2["default"])(EnhancedStep, _Component);

    function EnhancedStep() {
      (0, _classCallCheck2["default"])(this, EnhancedStep);
      return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(EnhancedStep).apply(this, arguments));
    }

    (0, _createClass2["default"])(EnhancedStep, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            size = _this$props.size,
            windConfig = _this$props.windConfig,
            className = _this$props.className,
            restProps = (0, _objectWithoutProperties2["default"])(_this$props, ["size", "windConfig", "className"]);
        var prefix = windConfig && windConfig.prefix ? windConfig.prefix : 'next-';
        var sizeClassName = "".concat(prefix, "enhanced-step-size-").concat(size);
        return _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, restProps, {
          className: (0, _classnames["default"])(sizeClassName, className)
        }));
      }
    }]);
    return EnhancedStep;
  }(_react.Component);

  (0, _defineProperty2["default"])(EnhancedStep, "displayName", "WindEnhanced(".concat((0, _getDisplayName["default"])(WrappedComponent, 'Step'), ")"));
  (0, _defineProperty2["default"])(EnhancedStep, "propTypes", {
    size: _propTypes["default"].oneOf(['medium', 'small']),
    className: _propTypes["default"].string
  });
  (0, _defineProperty2["default"])(EnhancedStep, "defaultProps", {
    size: 'medium'
  });
  (0, _hoistNonReactStatics["default"])(EnhancedStep, _step["default"]);
  return EnhancedStep;
};

var _default = (0, _withWindConfig["default"])(enhance(_step["default"]));

exports["default"] = _default;